import { FC, ReactNode } from "react";
import {
  Modal,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from "@chakra-ui/react";
import { XClose } from "~/icons";

interface Props {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

export const ModalWrapper: FC<Props> = ({ children, isOpen, onClose }) => {
  return (
    <Modal
      closeOnOverlayClick={true}
      isOpen={isOpen}
      onClose={onClose}
      scrollBehavior="inside"
      size="md"
    >
      <ModalOverlay />
      <ModalContent bg="bg-lighter" overflow="hidden">
        <ModalCloseButton
          as={XClose}
          cursor="pointer"
          h={6}
          onClick={onClose}
          right={3}
          top={3}
          w={6}
        />
        {children}
      </ModalContent>
    </Modal>
  );
};
